(() => {
  function init() {
    document.querySelectorAll('[data-store-menu]').forEach(menu => {
      if (menu.dataset.ready) return; menu.dataset.ready = 'true';
      const toggle = menu.querySelector('summary');
      const close = (restore = true) => { menu.open = false; if (restore) toggle.focus(); };
      menu.addEventListener('toggle', () => { toggle.setAttribute('aria-expanded', String(menu.open)); toggle.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu'); document.body.classList.toggle('tp-menu-open', menu.open); });
      menu.querySelectorAll('[data-menu-close]').forEach(b => b.addEventListener('click', () => close()));
      menu.addEventListener('click', e => { if (e.target.closest('a')) close(false); });
      menu.addEventListener('keydown', e => {
        if (!menu.open) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        if (e.key === 'Tab') {
          const targets = [toggle, ...menu.querySelectorAll('.tp-menu-panel a, .tp-menu-panel button')];
          const first = targets[0], last = targets[targets.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    });
  }
  const openCategory = key => {
    const card = [...document.querySelectorAll('[data-category-key]')].find(c => c.dataset.categoryKey === key);
    if (!card) return false;
    card.click(); return true;
  };
  document.addEventListener('click', e => {
    const link = e.target.closest('[data-open-category]');
    if (link && document.querySelector('[data-home-layout]')) { e.preventDefault(); openCategory(link.dataset.openCategory); }
    if (e.target.closest('[data-focus-search]')) { e.preventDefault(); document.getElementById('TekSearch')?.focus(); }
  });
  init(); document.addEventListener('shopify:section:load', init);
  const category = new URLSearchParams(location.search).get('category');
  if (category) openCategory(category);
})();

// The homepage's featured products share the same controls in Shopify and the local preview.
(() => {
  if (window.tekFeaturedCarouselLoaded) return;
  window.tekFeaturedCarouselLoaded = true;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    if (root.dataset.featuredReady) return;
    root.dataset.featuredReady = 'true';
    const track = root.querySelector('[data-featured-track]');
    const controls = root.querySelector('[data-featured-controls]');
    const pause = root.querySelector('[data-featured-pause]');
    const cards = [...track.children];
    cards.forEach(card => { card.querySelector('img').loading = 'eager'; });
    let paused = motion.matches;
    let visible = false;
    let index = 0;
    let count = 0;
    function updateControl() {
      pause.textContent = paused ? 'Play' : 'Pause';
      pause.setAttribute('aria-label', paused ? 'Play featured items' : 'Pause featured items');
    }
    function show() {
      const current = new Map();
      for (let slot = 0; slot < count; slot++) current.set((index + slot) % cards.length, slot + 1);
      cards.forEach((card, cardIndex) => {
        const active = current.has(cardIndex);
        if (active) card.style.setProperty('--featured-slot', current.get(cardIndex));
        card.classList.toggle('is-current', active);
        card.setAttribute('aria-hidden', String(!active));
        card.tabIndex = active ? 0 : -1;
      });
    }
    function measure() {
      const nextCount = Math.min(cards.length, Number(getComputedStyle(track).getPropertyValue('--featured-visible')) || 3);
      controls.hidden = cards.length <= nextCount;
      if (count !== nextCount) {
        count = nextCount;
        cards.forEach(card => card.style.removeProperty('--featured-slot'));
        show();
      }
    }
    function stop() { paused = true; updateControl(); }
    function move(direction) {
      if (cards.length <= count) return;
      index = (index + direction * count + cards.length) % cards.length;
      show();
    }
    root.querySelector('[data-featured-prev]').addEventListener('click', () => { stop(); move(-1); });
    root.querySelector('[data-featured-next]').addEventListener('click', () => { stop(); move(1); });
    pause.addEventListener('click', () => { paused = !paused; updateControl(); });
    // Keep a product in place while the shopper reads or selects it.
    track.addEventListener('focusin', stop);
    track.addEventListener('pointerdown', stop);
    const onMotion = () => { paused = motion.matches; updateControl(); };
    motion.addEventListener('change', onMotion);
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
    observer.observe(root);
    const resize = new ResizeObserver(measure);
    resize.observe(track);
    measure();
    updateControl();
    const timer = setInterval(() => {
      if (!root.isConnected) {
        clearInterval(timer); observer.disconnect(); resize.disconnect(); motion.removeEventListener('change', onMotion); return;
      }
      if (paused || !visible || document.hidden || track.matches(':hover, :focus-within')) return;
      move(1);
    }, 5000);
  }
  const scan = () => document.querySelectorAll('[data-featured-carousel]').forEach(init);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
